var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11391 7.3926C5.89413 7.39345 5.68071 7.46647 5.50647 7.60042C5.33222 7.73438 5.20679 7.92185 5.14947 8.13403C5.09214 8.34621 5.10609 8.57134 5.18917 8.77481C5.27225 8.97829 5.41985 9.14885 5.6093 9.26027V10.691H6.63083V9.26027C6.78072 9.17161 6.90511 9.04568 6.99192 8.89471C7.07872 8.74374 7.12499 8.57288 7.12621 8.39874C7.12622 8.26609 7.09999 8.13475 7.04904 8.01228C6.99809 7.88981 6.92343 7.77862 6.82935 7.68511C6.73526 7.5916 6.62362 7.51761 6.50084 7.46741C6.37806 7.41721 6.24656 7.39179 6.11391 7.3926Z",
    stroke: "#364A63",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89531 5.08398H2.32922C1.59511 5.08398 1 5.6791 1 6.4132V11.6716C1 12.4057 1.59511 13.0008 2.32922 13.0008H9.89531C10.6294 13.0008 11.2245 12.4057 11.2245 11.6716V6.4132C11.2245 5.6791 10.6294 5.08398 9.89531 5.08398Z",
    stroke: "#364A63",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83691 5.08304V4.27997C2.83691 3.41007 3.18248 2.5758 3.7976 1.96068C4.41271 1.34557 5.24698 1 6.11689 1C6.98679 1 7.82106 1.34557 8.43618 1.96068C9.05129 2.5758 9.39686 3.41007 9.39686 4.27997V5.08304",
    stroke: "#364A63",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.d4d34ce58808ef5c0eef4950db64b236.svg";
export { ForwardRef as ReactComponent };